export const PARTIAL_ADDRESS = 'warning_partial_address';

export default {
  PARTIAL_ADDRESS,
};
